import { AdjustResult, PairedSalesAnalysisFeature, StudiesPair } from '@aloft/toolkit-shared';

import { CustomToolkitPropertyTable } from '../../../components/ToolkitPropertyTable/CustomToolkitPropertyTable.js';
import { CustomTPColumn } from '../../../components/ToolkitPropertyTable/types.js';
import { getColumnDefForTerm } from '../../adjustPairedSalesStandalone/components/PickPair/getColumnDefForTerm.js';
import {
  SHARED_RECONCILIATION_COLUMNS,
  SHARED_RECONCILIATION_COLUMN_CONFIG,
} from '../../adjustPairedSalesStandalone/reconciliationTableSharedColumns.js';

const [address, salePrice, adjustedPrice, difference] = SHARED_RECONCILIATION_COLUMNS;

const rightColumns: CustomTPColumn<
  StudiesPair & { result: AdjustResult; feature: PairedSalesAnalysisFeature }
>[] = [
  'grossLivingArea',
  'site',
  'aboveGradeBedroomCount',
  'aboveGradeFullBathCount',
  'aboveGradeHalfBathCount',
  'yearBuilt',
  'closeDate',
  salePrice,
  adjustedPrice,
  difference,
];

function getRightColumns(selectedTerm: PairedSalesAnalysisFeature) {
  return rightColumns.filter((x) => x !== selectedTerm);
}

export const StudyCardPairsTable = ({
  pairs,
  term,
}: {
  pairs: Array<StudiesPair & { result: AdjustResult; feature: PairedSalesAnalysisFeature }>;
  term: PairedSalesAnalysisFeature;
}) => {
  return (
    <CustomToolkitPropertyTable
      columns={[
        address,
        ...getColumnDefForTerm<
          StudiesPair & { result: AdjustResult; feature: PairedSalesAnalysisFeature }
        >(term),
        ...getRightColumns(term),
      ]}
      data={pairs}
      tpColumnConfig={SHARED_RECONCILIATION_COLUMN_CONFIG}
      selectedRowIndices={[]}
      activeRowIndex={null}
      emptyTableMessage="No pairs selected"
    />
  );
};
